/**
 * Formatteert een bedrag zoals documentStore.formatNumber() dat doet (nl-NL, EUR, twee
 * decimalen). Hier los gedupliceerd zodat een leesveld de volledige document-store
 * (met API-client en lodash) niet hoeft te laden; de pariteitstest bewaakt dat beide
 * hetzelfde tonen.
 */
export function formatPrice(value: unknown): string {
    if (value === null || value === undefined) {
        return ''
    }

    return new Intl.NumberFormat('nl-NL', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(value as number)
}

/**
 * Toont een getal met komma als decimaalteken (EU-formaat), met behoud van het
 * aantal decimalen.
 */
export function formatEuNumber(value: unknown): string {
    if (value === null || value === undefined || value === '') {
        return ''
    }

    return String(value).replaceAll('.', ',')
}
